import clsx from 'clsx';
import * as React from 'react';

interface SectionTitleProps {
	title?: string;
	middleContent?: React.ReactNode;
	rightContent?: React.ReactNode;
	className?: string;
}

export const PageTitle = ({ title, middleContent, rightContent, className }: SectionTitleProps) => (
  <div className={clsx(className, 'flex items-center', title && 'pt-3 mb-3', !title && 'my-3')}>
    <h1 className="pb-2 text-3xl font-extrabold tracking-tight text-gray-800 border-b border-gray-400">
      {title}
    </h1>
    {middleContent ? middleContent : null}
    {rightContent ? <div className="ml-auto">{rightContent}</div> : null}
  </div>
);
